import { defineComponent as _defineComponent } from 'vue'
import ServerContextService from '@/core/server-context.service';
import DatePicker from 'vue2-datepicker';
import datePickerLocale from '@/core/datepickerlocales.service';
import DatePickerService from '@/services/datepicker.service';
import InputField from '@/ui/shared/InputField.vue';
import { format, parse } from 'date-fns';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DatePickerCtrl',
  props: {
    value: null,
    label: null,
    minDate: null,
    maxDate: null,
    clearable: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({(e: 'input', value: Date | null) }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    value?: Date,
    label?: string,
    minDate?: Date,
    maxDate?: Date
    clearable?: boolean
}

const currentDatePickerLocale: object = datePickerLocale[ServerContextService.twoLetterISOLanguageName];
const hover = ref(false);
const activateHover = ref(false);

const input = ref<InputField>(null);





const inputDate = computed<string>(() => {
    if (props.value === null) {
        return '';
    }
    return format(props.value, ServerContextService.dateFormat);
});

const date = computed<Date>({
    get(): Date {
        return props.value;
    },
    set(newValue: Date): void {
        emit('input', newValue);
    }
});

const showDatePicker = computed<boolean>(() => {
    return activateHover.value && hover.value;
});

const hasValue = computed<boolean>(() => {
    return !!date.value;
});

const dateFormat = computed<string>(() => {
    return ServerContextService.dateFormat.toUpperCase();
});

function disabledDate(date): boolean {
    return date < props.minDate || date > props.maxDate;
}

function onFocus(): void {
    activateHover.value = true;
}

function onMouseover(): void {
    hover.value = true;
}

function onMouseleave(): void {
    hover.value = false;
    activateHover.value = false;
    (input.value.$refs.input as HTMLInputElement).blur();
}

function onInputDate(value: string) {
    if (DatePickerService.validateDateStringLength(value)) {
        return;
    }

    const dateValue = parse(DatePickerService.stripSpecialCharacters(value), DatePickerService.stripSpecialCharacters(ServerContextService.dateFormat), new Date());

    if (DatePickerService.validateDateYear(dateValue) || disabledDate(dateValue)) {
        return;
    }

    date.value = dateValue;
}

function clear() {
    emit('input', null);
}

return { __sfc: true,currentDatePickerLocale, hover, activateHover, input, props, emit, inputDate, date, showDatePicker, hasValue, dateFormat, disabledDate, onFocus, onMouseover, onMouseleave, onInputDate, clear, DatePicker, InputField }
}

})